import React, { ReactNode, useContext, useEffect, useState } from 'react';

import SupportLinesContext from '@totem/components/supportLines/supportLinesContext';
import { OwnerItem, SupportLine } from '@totem/components/supportLines/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  children?: ReactNode;
  owner: OwnerItem;
};
const SupportLinesContainer = ({ owner, children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [data, setData] = useState<OwnerItem>(owner);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<SupportLine>(null);
  useEffect(() => {
    setRefreshData(true);
  }, [userProfile.organization.id]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);
      const uri = `${DEVICES_ENDPOINT}/supportLines/${owner.objectId}`;
      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: OwnerItem[]) => {
          if (isNotNull(result)) {
            if (result.length > 0) {
              setData(result[0]);
            }
          }
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [owner, refreshData, getApiToken]);
  const handleAction = (newAction: string, newActionItem: SupportLine) => {
    switch (newAction) {
      case 'refresh':
        setRefreshData(true);

        setAction('');

        setActionItem(null);
        break;
      default:
        setAction(newAction);

        setActionItem(newActionItem);
        break;
    }
  };
  return (
    <SupportLinesContext.Provider
      value={{
        loading: isLoading,
        data,
        action,
        actionItem,
        owner,
        onAction: handleAction,
      }}
    >
      {children}
    </SupportLinesContext.Provider>
  );
};
export default SupportLinesContainer;
